var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_510)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45483 58.9517V45.4552",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3573 58.9517V45.4552",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_306_510",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H75V75H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_306_510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6234 73.9014V68.6829",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1888 73.9014V68.6829",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44934 58.9487V49.4003",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3519 58.9487V49.4003",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_306_510",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H75V75H0V7.62939e-06Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_306_510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8627 51.535L42.7753 51.4887C42.0224 51.0907 41.5513 50.309 41.5513 49.4573V47.6602",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4487 47.3007V49.4574C33.4487 50.309 32.9777 51.0908 32.2248 51.4888L32.1372 51.5351",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6179 73.8984V68.6799",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1835 73.8984V68.6799",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2132 51.5549L45.5896 52.1728C46.3752 52.5255 46.5647 53.5554 45.9562 54.1648L42.1447 57.9822C41.6613 58.4529 40.9002 58.4819 40.3824 58.0493L37.5 55.6342L42.4893 51.745C42.9867 51.3733 43.6466 51.3005 44.2132 51.5549Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7868 51.5549L29.4104 52.1728C28.6248 52.5255 28.4353 53.5554 29.0438 54.1648L32.8553 57.9822C33.3387 58.4529 34.0998 58.4819 34.6177 58.0493L37.5 55.6342L32.5109 51.745C32.0133 51.3733 31.3534 51.3005 30.7868 51.5549Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5989 63.1143C54.9126 56.424 49.3108 53.4691 45.7417 52.2549",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2584 52.2549C25.4512 53.5501 19.3314 56.8256 19.3314 64.5027V70.9269C19.3314 72.568 20.6618 73.8984 22.303 73.8984H52.697C54.3381 73.8984 55.6685 72.568 55.6685 70.9269V68.2036",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2687 27.5897H45.1865C44.7315 27.5897 44.3625 27.2209 44.3625 26.7657C44.3625 25.4187 43.2705 24.3265 41.9233 24.3265H34.1592C30.7039 24.3265 27.903 27.1275 27.903 30.5828V34.7172C27.903 35.3245 28.2872 35.8653 28.8607 36.065L30.4018 36.6016C30.9405 36.7892 31.503 36.3887 31.5021 35.8183L31.4987 32.9028C31.4928 31.485 32.6234 30.3307 34.0242 30.3247L34.0547 30.3246C34.4835 30.3228 34.9075 30.3893 35.3126 30.5194C36.0303 30.7501 36.774 30.8899 37.5279 30.8866H38.0832C38.837 30.8899 39.5805 30.7501 40.2983 30.5194C40.7033 30.3893 41.1274 30.3228 41.5562 30.3246L41.5866 30.3247C42.9875 30.3307 44.1182 31.485 44.1122 32.9028L44.1094 35.8185C44.1087 36.3889 44.6712 36.7892 45.2096 36.6016L46.7502 36.065C47.3237 35.8653 47.7081 35.3245 47.7081 34.7173V30.029C47.7081 28.6819 46.6159 27.5897 45.2687 27.5897Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0319 35.3079C27.5266 35.688 27.1987 36.2909 27.1991 36.9719L27.2006 38.8601C27.2014 40.0097 28.1338 40.9411 29.2834 40.9405L29.8181 40.9402C29.872 43.0667 30.7635 45.11 32.3643 46.4933C33.6532 47.607 35.4623 48.5763 37.8469 48.593C40.2312 48.5558 42.0323 47.5713 43.3118 46.4467C44.901 45.0495 45.7754 42.9989 45.8117 40.8719L46.3593 40.8696C47.1588 40.8662 47.8042 40.2075 47.8008 39.3982L47.7941 36.2769C47.7927 35.9586 47.6901 35.6652 47.5188 35.4257",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69224 32.7641C2.6895 34.7043 1.16284 37.4406 1.16284 41.275V55.406C1.16284 57.3626 2.74897 58.9487 4.70557 58.9487H20.6312",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0583 29.1988C26.0943 28.4774 24.6067 28.2609 24.6067 28.2609C22.2956 32.3794 16.3671 32.3794 14.0562 28.2609C14.0562 28.2609 11.7196 28.6 9.03601 29.8491",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3689 58.9487H70.2945C72.2509 58.9487 73.8371 57.3626 73.8371 55.406V41.275C73.8371 30.1322 60.9438 28.2608 60.9438 28.2608C59.0659 33.0626 52.2712 33.0626 50.3933 28.2608C50.3933 28.2608 49.172 28.4387 47.4821 29.0085",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4372 4.36184H63.3548C62.9035 4.36184 62.5294 3.9987 62.531 3.54738C62.5361 2.19577 61.442 1.0986 60.0917 1.0986H52.3276C48.8724 1.0986 46.0713 3.89968 46.0713 7.35495V11.4895C46.0713 12.0966 46.4557 12.6375 47.0292 12.8371L47.1302 12.8723H49.6213C53.3105 12.8723 56.4756 10.7783 58.7057 8.70422C59.9656 7.53234 62.0253 8.38474 62.0751 10.1048C62.076 10.131 62.0766 10.1573 62.0771 10.1839C62.1059 11.6623 63.3047 12.8723 64.7833 12.8723H64.8179L64.9187 12.8373C65.4922 12.6375 65.8764 12.0968 65.8764 11.4895V6.80124C65.8764 5.45402 64.7844 4.36184 63.4372 4.36184Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7169 4.39918C26.9136 4.39918 26.1964 3.89586 25.9232 3.14044L25.7083 2.54601C25.4351 1.79059 24.7179 1.28727 23.9146 1.28727H10.4227C9.65393 1.28727 9.03064 1.91056 9.03064 2.67946V4.7796C9.03064 7.32257 11.092 9.3839 13.6348 9.3839H22.4277C23.8023 9.3839 25.0682 10.1318 25.7315 11.3359C26.3946 12.5402 27.6605 13.2881 29.0353 13.2881C29.3605 13.2883 29.6243 13.0245 29.6243 12.6991V6.30656C29.6243 5.25319 28.7703 4.39918 27.7169 4.39918Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6507 8.93518C11.6303 9.16633 11.6183 9.40378 11.6193 9.65134L11.6258 11.2009L11.6284 11.849L11.1116 11.8493C9.96155 11.8499 9.02991 12.7827 9.03064 13.9328L9.0321 15.8208C9.03284 16.9704 9.96536 17.9018 11.115 17.9012L11.6496 17.9011C11.7035 20.0276 12.595 22.0707 14.1958 23.4541C15.4847 24.5678 17.2938 25.537 19.6784 25.5538C22.0628 25.5166 23.8638 24.5321 25.1432 23.4074C26.7325 22.0104 27.6069 19.9597 27.6432 17.8328L28.1908 17.8304C28.9903 17.8271 29.6357 17.1682 29.6323 16.3589L29.6255 13.2377C29.6252 13.123 29.6102 13.0121 29.5853 12.9052",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2004 12.08C45.6952 12.4603 45.3672 13.0632 45.3677 13.7442L45.3691 15.6323C45.3699 16.7819 46.3024 17.7132 47.452 17.7127L47.9867 17.7125C48.0406 19.8389 48.9319 21.8822 50.5329 23.2654C51.8218 24.3792 53.6309 25.3484 56.0155 25.3651C58.3998 25.3281 60.2008 24.3434 61.4804 23.2189C63.0696 21.8218 63.9439 19.7711 63.9803 17.6442L64.5278 17.6419C65.3273 17.6384 65.9728 16.9796 65.9694 16.1703L65.9626 13.049C65.9613 12.7307 65.8586 12.4373 65.6874 12.1978",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6172 24.0729V26.2296C51.6172 27.0812 51.1462 27.863 50.3933 28.2609",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9438 28.2609C60.1909 27.8629 59.72 27.0811 59.72 26.2294V24.4324",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2802 24.2615V26.2295C15.2802 27.0811 14.8092 27.8629 14.0563 28.2609",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6067 28.2609C23.8538 27.8629 23.3828 27.0811 23.3828 26.2294V24.6211",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/Team-icon.fba0db74547739a920af1b1b7ad33193.svg";
export { ForwardRef as ReactComponent };